export default "/_next/static/images/jocelyn-mangan-45d24d075630c95ea82f16fdee15d8aa.png";